module.exports = __webpack_public_path__ + "img/logo.6b95a32d.png";